module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/DownloadQr-85ccfe8a7c4fa05d3a7c46969fbf26d1.png";